<div class="fixed inset-0 bg-black/50 flex items-center justify-center z-[1100] p-4"
     (mousedown)="close()">
  <div class="bm-card bm-card-sm bg-base-100 shadow-xl max-w-lg w-full max-h-[90vh] overflow-y-auto"
       (mousedown)="$event.stopPropagation()">
    <div class="bm-card-body">
      <div class="bm-card-title">
        Material-Storno
        @if (articleDescription) {
          <span class="text-sm font-normal opacity-70">— {{ articleDescription }}</span>
        }
      </div>

      @if (articleSn) {
        <p class="text-xs opacity-60 -mt-2 mb-2">SN: <span class="font-mono">{{ articleSn }}</span></p>
      }

      <fieldset class="bm-fieldset">
        <label class="bm-fieldset-label">Zurückbuchen in Ziel-Lager</label>
        @if (loadingWarehouses()) {
          <span class="text-xs opacity-60 italic">Lager werden geladen…</span>
        } @else {
          <select class="bm-select w-full"
                  [ngModel]="selectedWarehouseId()"
                  (ngModelChange)="onWarehouseChange($event ? +$event : null)">
            <option [ngValue]="null">— bitte wählen —</option>
            @for (wh of warehouses(); track wh.id) {
              <option [ngValue]="wh.id">{{ wh.label || wh.name }}</option>
            }
          </select>
        }
      </fieldset>

      <fieldset class="bm-fieldset">
        <label class="bm-fieldset-label">Lagerplatz</label>
        @if (selectedWarehouseId() == null) {
          <span class="text-xs opacity-60 italic">Zuerst ein Lager wählen.</span>
        } @else if (loadingBins()) {
          <span class="text-xs opacity-60 italic">Lagerplätze werden geladen…</span>
        } @else if (storageBins().length === 0) {
          <span class="text-xs opacity-60 italic">Keine Lagerplätze im gewählten Lager.</span>
        } @else {
          <select class="bm-select w-full"
                  [ngModel]="selectedStorageBinId()"
                  (ngModelChange)="selectedStorageBinId.set($event ? +$event : null)">
            <option [ngValue]="null">— bitte wählen —</option>
            @for (bin of storageBins(); track bin.id) {
              <option [ngValue]="bin.id">{{ bin.name }}</option>
            }
          </select>
        }
      </fieldset>

      <fieldset class="bm-fieldset mt-2">
        <label class="flex items-center gap-2 cursor-pointer">
          <input type="checkbox" class="checkbox checkbox-sm"
                 [ngModel]="badPart()"
                 (ngModelChange)="badPart.set($event)" />
          <span>Artikel als defekt markieren (Bad Part)</span>
        </label>
        @if (badPart()) {
          <input type="text" class="bm-input w-full mt-2"
                 placeholder="Fehlerbeschreibung (optional)"
                 [ngModel]="badPartDescription()"
                 (ngModelChange)="badPartDescription.set($event)" />
        }
      </fieldset>

      @if (errorMessage(); as err) {
        <div class="bm-alert bm-alert-error bm-alert-soft mt-3">{{ err }}</div>
      }

      <div class="flex justify-end gap-2 mt-4">
        <button type="button" class="bm-btn bm-btn-ghost"
                [disabled]="submitting()"
                (click)="close()">Abbrechen</button>
        <button type="button" class="bm-btn bm-btn-error"
                [disabled]="!canSubmit()"
                (click)="submit()">
          @if (submitting()) { Storniere… } @else { Stornieren }
        </button>
      </div>
    </div>
  </div>
</div>
